import $http from '../../axios'

export async function fetch({commit}) {
    await $http.get('api_url', )
        .then((response) => {
            commit('', response.data.data)
        })
        .catch((error) => {
           
        })
}



// WEBPACK FOOTER //
// ./src/modules/load_images/actions.js